/* eslint-disable */

export const protobufPackage = "tecton_proto.common";

export enum ServerGroupType {
  SERVER_GROUP_TYPE_UNSPECIFIED = "SERVER_GROUP_TYPE_UNSPECIFIED",
  SERVER_GROUP_TYPE_FEATURE_SERVER_GROUP = "SERVER_GROUP_TYPE_FEATURE_SERVER_GROUP",
  SERVER_GROUP_TYPE_TRANSFORM_SERVER_GROUP = "SERVER_GROUP_TYPE_TRANSFORM_SERVER_GROUP",
  SERVER_GROUP_TYPE_INGEST_SERVER_GROUP = "SERVER_GROUP_TYPE_INGEST_SERVER_GROUP",
}
